var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "error_outline_black_24dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "**DASHBOARD**",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard-blockCard",
    transform: "translate(-681.000000, -116.000000)",
    fill: "#FF3A3A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error_outline_black_24dp",
    transform: "translate(681.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1,50.7 L42.9,50.7 L42.9,58.5 L35.1,58.5 L35.1,50.7 Z M35.1,19.5 L42.9,19.5 L42.9,42.9 L35.1,42.9 L35.1,19.5 Z M38.961,0 C17.433,0 0,17.472 0,39 C0,60.528 17.433,78 38.961,78 C60.528,78 78,60.528 78,39 C78,17.472 60.528,0 38.961,0 Z M39,70.2 C21.762,70.2 7.8,56.238 7.8,39 C7.8,21.762 21.762,7.8 39,7.8 C56.238,7.8 70.2,21.762 70.2,39 C70.2,56.238 56.238,70.2 39,70.2 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlock);
export default __webpack_public_path__ + "static/media/ic_block.2dee12f6db38d7bffc1242a418215240.svg";
export { ForwardRef as ReactComponent };